module.exports = __webpack_public_path__ + "img/facebook.a9fdc1b7.svg";